import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    padding: '22px 16px',
    borderBottom: `1px solid ${theme.colors.iron}`,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: 'fit-content',
  },

  content: {
    marginLeft: '51px',
    transition: '.3s all',
    maxHeight: '1500px',
    overflow: 'hidden',
  },

  collapsedContent: {
    maxHeight: 0,
  },

  expandIcon: {
    transition: '.5s all',
    marginRight: '16px',
    fill: theme.colors.primary,
  },

  collapsedIcon: {
    transform: 'rotate(-90deg)',
  },
}

export default styles
